<div *ngIf="(isLoggedIn$ | async) && (banner$ | async) as banner">
  <div
    *ngIf="banner.isActive && banner.message?.trim()"
    class="custom-banner"
    role="region"
    #bannerContainer
    id="site-banner"
    aria-label="Site notice banner"
  >
    <p class="sr-only" id="banner-live">
      Site notice: {{ banner.message }}
    </p>

    <div class="marquee" aria-hidden="true">
      <div #marqueeContent class="marquee-content"
           [style.--duration]="marqueeDuration"
           [style.--startX.px]="startX"
           [style.--endX.px]="endX"
           [style.--delay]="marqueeDelay">
        <span class="marquee-text">{{ banner.message }}</span>
      </div>
    </div>
  </div>
</div>

<nav aria-label="Skip navigation">
  <a href="#main-content" class="skip-to-content-link" (click)="skipToContent($event)">Skip to Main Content</a>
</nav>

<router-outlet></router-outlet>

<div
  *ngIf="authService.sessionExpiringVisible()"
  class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto"
  role="presentation">

  <section
    #sessionExpiringDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg my-auto"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="session-expiring-title"
    aria-describedby="session-expiring-message"
    tabindex="-1"
    (keydown)="onSessionExpiringKeydown($event, sessionExpiringDialog)">

    <h2 id="session-expiring-title" class="text-xl font-semibold mb-4">
      Session Expiring
    </h2>

    <p id="session-expiring-message" class="mb-4">
      Your session is about to expire. Would you like to stay signed in?
    </p>

    <div class="flex justify-end gap-2">
      <prism-btn
        btnClass="bg-white text-dark-purple font-bold border-2 rounded-xl border-dark-purple"
        (click)="authService.declineSessionExtension()">
        Logout
      </prism-btn>
      <prism-btn (click)="authService.confirmSessionExtension()">
        Yes, keep me signed in
      </prism-btn>
    </div>
  </section>
</div>

<div
  *ngIf="authService.sessionTimeoutVisible()"
  class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto"
  role="presentation">

  <section
    #sessionTimeoutDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg my-auto"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="session-timeout-title"
    aria-describedby="session-timeout-message"
    tabindex="-1"
    (keydown)="onSessionTimeoutKeydown($event, sessionTimeoutDialog)">

    <h2 id="session-timeout-title" class="text-xl font-semibold mb-4">
      Session Timed Out
    </h2>

    <p id="session-timeout-message" class="mb-4">
      Your session has expired due to inactivity. Please log back in to access the system.
    </p>

    <div class="flex justify-end">
      <prism-btn (click)="authService.acknowledgeSessionTimeout()">
        OK
      </prism-btn>
    </div>
  </section>
</div>